import React, { useEffect } from 'react'
import { BodyText, Button, Dialog } from '@paypalcorp/pp-react'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import clientLogger from 'ppbl/utils/client-logger'
import './index.css'
import { promotionalAlertConstants } from 'ppbl/utils/cleverConstants'

type PromotionalAlertProps = {
  isPromotionalAlert: boolean
  opportunityId: string
  setIsPromotionalAlert?: (value: boolean) => void
  handlePromotionalAlert?: (value: string) => void
}

const PromotionalAlert: React.FC<PromotionalAlertProps> = ({
  isPromotionalAlert,
  opportunityId,
  setIsPromotionalAlert,
  handlePromotionalAlert,
}) => {
  useEffect(() => {
    clientLogger.cleverInfo(
      `Pricing Mismatch alert appeared for opportunityId: ${opportunityId}`,
    )
  }, [opportunityId])

  return (
    <div>
      <Dialog
        title="Pricing Mismatch Alert"
        id="promotionalalertId"
        isOpen={isPromotionalAlert}
        center
        headerClassName="dialogHeaderClassWrapper"
        containerClassName="containerClasses"
        className="wrapperClasses"
        footerContents={
          <div className="dialogButtonWrapper">
            <Button
              secondary
              onClick={() => {
                handlePromotionalAlert(promotionalAlertConstants.cancel)
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handlePromotionalAlert(promotionalAlertConstants.confirm)
              }}
            >
              Confirm
            </Button>
          </div>
        }
        footerAlign="center"
        onClose={() => setIsPromotionalAlert(false)}
      >
        <BodyText>
          The pricing tier you've selected doesn't match the promotion applied to the opportunity. Do you want to continue?
        </BodyText>
      </Dialog>
    </div>
  )
}

export default PromotionalAlert
